var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrochipLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339.115,
    height: 79.867,
    viewBox: "0 0 89.724 21.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.992 40.364h252.88V99.2H39.992z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -13.86 35.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.481 18.551h-.061l-5.72-14.812c-.53-1.38-1.701-2.511-3.342-2.511-1.639 0-2.938 1.364-3.341 2.511l-5.594 14.626h-.06L-21.207 0l-5.457.004 2.787 26.15c.183 1.444 1.367 3.088 2.977 3.088 2.468 0 3.456-1.444 3.948-2.888l6.318-15.878h.061l6.317 15.878c.556 1.444 1.513 2.888 3.95 2.888 1.61 0 2.794-1.644 2.976-3.425L5.432.004z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(136.41 59.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.729 81.479h5.086V59.364h-5.086zM265.03 81.479h5.086V59.364h-5.086z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 6.476 2.479 8.003 6.644 8.003h5.435c6.581 0 7.436.428 7.393-5.834l-11.919.02c-2.437 0-2.804-1.547-2.804-4.297V-4.49c0-3.207.458-4.429 2.645-4.429l12.265.01c0-3.726-.049-5.692-4.692-5.692H6.644C2.479-14.601 0-13.073 0-6.597z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(152.631 73.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.405c0 3.971-.957 6.568-4.518 6.568h-14.779v-22.115h4.624v5.743h8.093c1.437 0 1.894-.765 1.894-3.086v-2.657h4.625v3.756c0 3.635-1.146 4.521-2.521 4.889v.06C-.457-4.703 0-2.962 0 0m-4.498-.581c0-1.587-.458-2.321-1.708-2.321h-8.467v5.377h8.051c1.458 0 2.124-.368 2.124-2.322z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(194.374 73.507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 6.476 2.478 8.003 6.643 8.003h7.414C18.222 8.003 20.7 6.476 20.7 0v-6.597c0-6.476-2.478-8.004-6.643-8.004H6.643C2.478-14.601 0-13.073 0-6.597V0m4.748-4.49c0-3.207.459-4.429 2.645-4.429h5.915c2.186 0 2.644 1.222 2.644 4.429v2.382c0 2.75-.458 4.43-2.895 4.43H7.643c-2.436 0-2.895-1.68-2.895-4.43z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(197.163 73.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.622v-7.881h9.748V0h4.623v-22.115H14.37v8.37H4.622v-8.37H0z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(242.765 81.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-14.291v-22.115h4.623v5.559H1.207c3.271 0 4.249 3.789 4.249 7.086v1.895C5.456-3.238 4.394 0 0 0m.708-8.705c0-1.314-.416-2.352-1.5-2.352h-8.876v5.559h8.481C.208-5.498.708-6.353.708-7.85z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(287.416 81.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 6.476 2.478 8.003 6.643 8.003h5.436c6.581 0 7.407.429 7.365-5.834L7.553 2.19c-2.438 0-2.805-1.548-2.805-4.297v-2.382c0-3.208.459-4.429 2.645-4.429l12.266.01c0-3.727-.048-5.693-4.692-5.693H6.643C2.478-14.601 0-13.073 0-6.596z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(220.373 73.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a32.467 32.467 0 0 1-8.975 1.258c-16.976 0-30.739-12.974-30.739-28.98 0-16.005 13.763-28.979 30.739-28.979 15.6 0 28.476 10.958 30.463 25.152z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(79.785 97.447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.956 1.867-7.614 2.793-12.322 2.876-16.971.295-30.958-12.536-31.24-28.659a27.875 27.875 0 0 1 1.043-8.07l8.773 12.299 5.94-9.297s1.785-2.024.431-4.071c-.084-.128-8.059-11.144-8.059-11.144 5.508-5.771 13.257-9.294 22.094-9.448 8.573-.151 16.226 2.976 21.893 8.257l-18.66 29.454s2.943 4.13 5.244 7.403c2.534 3.602 4.815 1.087 5.576-.104C6.184-19.082 16.45-35.351 16.45-35.351l.005.094c1.052 2.419 1.591 3.152 1.704 6.636L0 0m-4.427-35.269s-4.967-7.244-5.476-7.935c-3.039-4.129-5.274.638-5.274.638L-30.983-17.72s2.942 4.129 5.245 7.402c2.533 3.603 4.814 1.087 5.575-.104 5.471-8.577 15.736-24.847 15.736-24.847",
    style: {
      fill: "#ee2223",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(83.602 96.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 1.361 1.103 2.361 2.405 2.361 1.291 0 2.392-1 2.392-2.361 0-1.37-1.101-2.372-2.392-2.372C1.103-2.372 0-1.37 0 0m2.405-1.977c1.071 0 1.916.84 1.916 1.977 0 1.121-.845 1.967-1.916 1.967C1.322 1.967.476 1.121.476 0c0-1.137.846-1.977 1.929-1.977m-.5.607h-.414v2.731H2.53c.645 0 .966-.24.966-.778 0-.489-.308-.702-.708-.752l.776-1.201H3.1L2.38-.186h-.475V-1.37M2.4.163c.35 0 .662.026.662.446 0 .336-.306.401-.595.401h-.562V.163z",
    style: {
      fill: "#5f6368",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(88.455 94.474)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrochipLogo);
export default __webpack_public_path__ + "static/media/Microchip_logo.944b851b39dc937ec74d38af9548ca24.svg";
export { ForwardRef as ReactComponent };